import React from 'react';
import HeaderDashboard from '../header/headerDashboard';
import { RequestBedForm } from '../forms/beds_request';

const Request = (props) => {
    return (
        <div style={{ backgroundColor: '#f7f8fa', minHeight: '100vh' }}>
            <HeaderDashboard />
            <div style={{ maxWidth: 620, margin: '0 auto', padding: '32px 16px' }}>
                <div style={{ marginBottom: 28 }}>
                    <h2 style={{ margin: 0, fontWeight: 700, fontSize: 22, color: '#1a1a2e' }}>
                        Nouvelle demande
                    </h2>
                    <p style={{ margin: '6px 0 0', color: '#888', fontSize: 14 }}>
                        Remplissez le formulaire pour soumettre une demande de lit.
                    </p>
                </div>
                <RequestBedForm />
            </div>
        </div>
    );
};

export default Request;
